import React, { useState, useEffect } from 'react';
import DataTable from '../../interfaccia/DataTableBase';
import stilePulsanti from '../../interfaccia/stilePulsanti';

function ListaScegli({
  lista,
  loading,
  nomeDato,
  labelDato,
  width,
  associa,
  obsoleto
}) {

  const [rows, setRows] = useState(
    lista
  )

  useEffect(() => {
    setRows(lista)
  }, [lista]);

  const columns = [
    {
        selector: row => row[nomeDato],
        name: labelDato,
        sortable: true,
        reorder: false,
        width: width + "px",
        cell: (row) => row["obsoleto"] ? <div className='black-30 strike'>{row[nomeDato]}</div> : <div>{row[nomeDato]}</div>       
      
    },
    {
        selector: row => row[nomeDato],
        name: "",
        sortable: false,
        ignoreRowClick: true,
        reorder: false,
        compact: false,
        width: 150,
        cell: (row) => <div className="rowitem">
            <button
                className={stilePulsanti.buttonClassesWhite}
                onClick={()=>{
                    associa(row.id)
                }}
            >
                ASSOCIA
            </button>
            </div>
       
      }
  ];

  return (
    <div
      className="h-100"
    >
      <DataTable
        data={rows}
        columns={columns}
        fixedHeader={false}
        fixedHeaderScrollHeight={"100px"}
        noTableHead
        striped={false}
        progressPending={loading}
        noDataComponent={<h3 className='ma5 pa5'>Nessun dato</h3>}
        progressComponent={<h3 className='ma5 pa5 '>carico i dati...</h3>}
        pagination
        paginationRowsPerPageOptions={[10,50,200]}
        paginationPerPage={10}
        paginationComponentOptions={{ rowsPerPageText: '', rangeSeparatorText: 'di', noRowsPerPage: false, selectAllRowsItem: false, selectAllRowsItemText: 'Seleziona tutti' }}
      />
      
    </div>
  )
}

export default ListaScegli;